module.exports = __webpack_public_path__ + "img/postmark-logo.dacebab6.svg";